import * as React from 'react';
import { RouteComponentProps } from 'react-router';

interface RegisterState {
    helpCtxId: string;
}

export class Register extends React.Component<RouteComponentProps<{}>, RegisterState> {
    constructor(props: RouteComponentProps<{}> ) {
        super(props);
        this.state = { helpCtxId: '' };
    }

    public render() {
        return <div>
            <h4>Регистрация</h4>

            <p>Для регистрации в программе необходимо направить запрос по электронной почте по адресу <a href="mailto:repo@otc-sytem.ru">repo@otc-sytem.ru</a></p>

        </div>;
    }
}
